import { EventEmitter, Component, ChangeDetectorRef, ViewChild, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AwButtonModule } from '@aw/ads-components/aw-button';
import { BehaviorSubject } from 'rxjs';
import { AwComponent } from '@aw/ads-components/aw-parent';
import { SCROLL_TIME_LIST_FORWARD, SCROLL_TIME_LIST_BACK } from '@aw/ads-components/src/constants';
import { take } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/dialog';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@aw/ads-components/aw-button';

const _c0 = ["panelFooter"];
const _c1 = ["modalTemplate"];
function AwPanelComponent_div_0_header_1_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.headerIcon);
} }
const _c2 = function (a1) { return { "panel-heading": true, "p-l0 p-r0": a1 }; };
function AwPanelComponent_div_0_header_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "header", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵtemplate(2, AwPanelComponent_div_0_header_1_i_2_Template, 2, 1, "i", 16);
    ɵngcc0.ɵɵelementStart(3, "h6", 17);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c2, ctx_r7.resetPaddings));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.headerIcon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.headerTitle);
} }
function AwPanelComponent_div_0_aw_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "aw-button", 19);
    ɵngcc0.ɵɵlistener("onClick", function AwPanelComponent_div_0_aw_button_2_Template_aw_button_onClick_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.hitAreaClicked(); });
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementStart(2, "span", 20);
    ɵngcc0.ɵɵelementStart(3, "i", 18);
    ɵngcc0.ɵɵtext(4, "chevron_right");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("elementId", ctx_r8.elementIdWithPrefix("panel-hit-area"))("styleClasses", ctx_r8.areaStyleClasses)("aw-aria-label", ctx_r8.hitAreaLabel);
} }
function AwPanelComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "p", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "aw-button", 23);
    ɵngcc0.ɵɵlistener("onClick", function AwPanelComponent_div_0_div_6_Template_aw_button_onClick_3_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.onSeeAllAppointmentsClick(); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.footerTitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("elementId", ctx_r9.elementIdWithPrefix("panel-see-all-btn"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r9.seeAllText, " ");
} }
function AwPanelComponent_div_0_ul_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li");
    ɵngcc0.ɵɵelementStart(2, "aw-button", 25);
    ɵngcc0.ɵɵlistener("onClick", function AwPanelComponent_div_0_ul_10_ng_container_1_Template_aw_button_onClick_2_listener() { ɵngcc0.ɵɵrestoreView(_r23); const appointment_r20 = ctx.$implicit; const ctx_r22 = ɵngcc0.ɵɵnextContext(3); return ctx_r22.appointmentItemClicked(appointment_r20); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const appointment_r20 = ctx.$implicit;
    const i_r21 = ctx.index;
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("progress", appointment_r20.loading && !ctx_r19.dialogRef)("elementId", ctx_r19.elementIdWithPrefix("panel-appointment-btn-" + i_r21));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r19.appointmentDisplayValue(appointment_r20), " ");
} }
function AwPanelComponent_div_0_ul_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul");
    ɵngcc0.ɵɵtemplate(1, AwPanelComponent_div_0_ul_10_ng_container_1_Template, 4, 3, "ng-container", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.appointments);
} }
function AwPanelComponent_div_0_aw_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "aw-button", 26);
    ɵngcc0.ɵɵlistener("onClick", function AwPanelComponent_div_0_aw_button_11_Template_aw_button_onClick_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); ɵngcc0.ɵɵnextContext(); const _r10 = ɵngcc0.ɵɵreference(9); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.sideScroll(_r10, "right", 80); });
    ɵngcc0.ɵɵelementStart(1, "span", 27);
    ɵngcc0.ɵɵtext(2, "navigate_before ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("aw-aria-label", ctx_r12.scrollBack);
} }
function AwPanelComponent_div_0_aw_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "aw-button", 28);
    ɵngcc0.ɵɵlistener("onClick", function AwPanelComponent_div_0_aw_button_12_Template_aw_button_onClick_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); ɵngcc0.ɵɵnextContext(); const _r10 = ɵngcc0.ɵɵreference(9); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.sideScroll(_r10, "left", 80); });
    ɵngcc0.ɵɵelementStart(1, "span", 27);
    ɵngcc0.ɵɵtext(2, "navigate_next");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("aw-aria-label", ctx_r13.scrollForward);
} }
const _c3 = function (a0, a1, a2) { return { "panel-footer": a0, "hide": a1, "p-l0 p-r0": a2 }; };
function AwPanelComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, AwPanelComponent_div_0_header_1_Template, 5, 5, "header", 5);
    ɵngcc0.ɵɵtemplate(2, AwPanelComponent_div_0_aw_button_2_Template, 5, 3, "aw-button", 6);
    ɵngcc0.ɵɵelementStart(3, "footer", 7);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵpipe(5, "async");
    ɵngcc0.ɵɵtemplate(6, AwPanelComponent_div_0_div_6_Template, 5, 3, "div", 8);
    ɵngcc0.ɵɵelementStart(7, "div", 9);
    ɵngcc0.ɵɵelementStart(8, "div", 10, 11);
    ɵngcc0.ɵɵlistener("scroll", function AwPanelComponent_div_0_Template_div_scroll_8_listener() { ɵngcc0.ɵɵrestoreView(_r29); const _r10 = ɵngcc0.ɵɵreference(9); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.scrollFooter(_r10); });
    ɵngcc0.ɵɵtemplate(10, AwPanelComponent_div_0_ul_10_Template, 2, 1, "ul", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, AwPanelComponent_div_0_aw_button_11_Template, 3, 1, "aw-button", 13);
    ɵngcc0.ɵɵtemplate(12, AwPanelComponent_div_0_aw_button_12_Template, 3, 1, "aw-button", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.classes);
    ɵngcc0.ɵɵattribute("automation", ctx_r0.automationValue)("id", ctx_r0.elementId)("tabindex", ctx_r0.tabindex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.headerIcon || ctx_r0.headerTitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isHitArea);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(16, _c3, ɵngcc0.ɵɵpipeBind1(4, 12, ctx_r0.isFooterVisible), !ɵngcc0.ɵɵpipeBind1(5, 14, ctx_r0.isFooterVisible), ctx_r0.resetPaddings));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.appointments.length);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.appointments.length)("ngIfElse", _r5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.footerScrollPosition > ctx_r0.footerScrollOffset);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.footerScrollPosition < ctx_r0.footerScrollWidth);
} }
function AwPanelComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵprojection(2, 2);
    ɵngcc0.ɵɵprojection(3, 3);
    ɵngcc0.ɵɵprojection(4, 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.styleClasses);
    ɵngcc0.ɵɵattribute("automation", ctx_r2.automationValue || "panelComponent")("id", ctx_r2.elementId)("tabindex", ctx_r2.tabindex);
} }
function AwPanelComponent_ng_template_3_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li");
    ɵngcc0.ɵɵelementStart(2, "aw-button", 25);
    ɵngcc0.ɵɵlistener("onClick", function AwPanelComponent_ng_template_3_ng_container_9_Template_aw_button_onClick_2_listener() { ɵngcc0.ɵɵrestoreView(_r34); const appointment_r31 = ctx.$implicit; const ctx_r33 = ɵngcc0.ɵɵnextContext(2); return ctx_r33.appointmentItemClicked(appointment_r31); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const appointment_r31 = ctx.$implicit;
    const i_r32 = ctx.index;
    const ctx_r30 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("progress", appointment_r31.loading && !!ctx_r30.dialogRef)("elementId", ctx_r30.elementIdWithPrefix("panel-modal-appointment-btn-" + i_r32));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r30.appointmentDisplayValue(appointment_r31), " ");
} }
function AwPanelComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵelementStart(1, "div", 31);
    ɵngcc0.ɵɵelementStart(2, "h4", 32);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "aw-button", 33);
    ɵngcc0.ɵɵelementStart(5, "i", 34);
    ɵngcc0.ɵɵtext(6, "close");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 35);
    ɵngcc0.ɵɵelementStart(8, "ul", 36);
    ɵngcc0.ɵɵtemplate(9, AwPanelComponent_ng_template_3_ng_container_9_Template, 4, 3, "ng-container", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.availableAppointmentsText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("elementId", ctx_r4.elementIdWithPrefix("panel-modal-close-btn"))("mat-dialog-close", true);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.appointments);
} }
function AwPanelComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 5);
} }
const _c4 = [[["", "aw-panel-hit-area", ""]], [["", 8, "panel-heading"]], [["", 8, "panel-body"]], [["", 8, "panel-footer"]], [["", 8, "panel-additional"]], [["", "aw-panel-footer-content", ""]]];
const _c5 = ["[aw-panel-hit-area]", ".panel-heading", ".panel-body", ".panel-footer", ".panel-additional", "[aw-panel-footer-content]"];
class AwPanelComponent extends AwComponent {
    constructor(matDialog, changeDetection) {
        super();
        this.matDialog = matDialog;
        this.changeDetection = changeDetection;
        this.isInteractive = false;
        this.automationValue = 'panelComponent';
        this.hitAreaChevronAriaLabel = 'Enter';
        this.seeAllText = 'See all';
        this.availableAppointmentsText = 'Available appointments';
        this.hitAreaClick = new EventEmitter();
        this.appointmentItemClick = new EventEmitter();
        this.appointments = [];
        this.appointmentDisplayValue = this.getAppointmentDisplayValue;
        this.isHitArea = true;
        this.isFooterVisible = new BehaviorSubject(false);
        this.footerScrollPosition = 0;
        this.footerScrollOffset = 0;
        this.scrollForward = SCROLL_TIME_LIST_FORWARD;
        this.scrollBack = SCROLL_TIME_LIST_BACK;
    }
    ngAfterViewInit() {
        if (this.panelFooter) {
            this.isFooterVisible.next(!!this.panelFooter.nativeElement.children.length);
        }
        this.changeDetection.detectChanges();
    }
    ngOnDestroy() {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }
    hitAreaClicked() {
        this.hitAreaClick.emit();
    }
    appointmentItemClicked(item) {
        this.appointmentItemClick.emit(item);
    }
    get classes() {
        const isHeaderEmpty = !(this.headerIcon || this.headerTitle);
        let classes = '';
        if (isHeaderEmpty) {
            classes = 'without-header';
        }
        if (!this.isFooterVisible.value) {
            classes = 'without-footer';
        }
        if (isHeaderEmpty && !this.isFooterVisible.value) {
            classes = 'only-body';
        }
        return `${classes} ${this.styleClasses || ''}`;
    }
    get footerScrollWidth() {
        const footerClientWidthOffset = this.panelFooter && this.panelFooter.nativeElement.clientWidth - this.footerScrollOffset;
        return this.panelFooter && this.panelFooter.nativeElement.scrollWidth - footerClientWidthOffset;
    }
    get areaStyleClasses() {
        return `flex items-center justify-between flex-row flex-auto panel-body panel-interactive-body ${this.resetPaddings ? 'p-l0 p-r0' : ''}`;
    }
    onSeeAllAppointmentsClick() {
        this.dialogRef = this.matDialog.open(this.modalTemplate, {
            panelClass: ['aw-modal', 'modal-sm', 'adaptive-dialog'],
            ariaLabelledBy: 'modalHeading',
            ariaDescribedBy: 'modalContent'
        });
        this.dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
            this.onAfterClose();
        });
    }
    onAfterClose() {
        if (this.dialogRef) {
            this.dialogRef.close();
            delete this.dialogRef;
        }
    }
    sideScroll(element, direction, step) {
        if (direction === 'left') {
            element.scrollTo({ left: (this.footerScrollPosition = element.scrollLeft + step), behavior: 'smooth' });
        }
        else {
            element.scrollTo({ left: (this.footerScrollPosition = element.scrollLeft - step), behavior: 'smooth' });
        }
    }
    scrollFooter(element) {
        this.footerScrollPosition = element.scrollLeft + this.footerScrollOffset;
    }
    elementIdWithPrefix(prefix) {
        return this.elementId ? `${prefix}-${this.elementId}` : undefined;
    }
    hideSeeAllDialog() {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }
    getAppointmentDisplayValue(item) {
        if (typeof item === 'object') {
            return item.value;
        }
        return String(item);
    }
}
AwPanelComponent.ɵfac = function AwPanelComponent_Factory(t) { return new (t || AwPanelComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MatDialog), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AwPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwPanelComponent, selectors: [["aw-panel"]], viewQuery: function AwPanelComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵstaticViewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panelFooter = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalTemplate = _t.first);
    } }, inputs: { isInteractive: "isInteractive", automationValue: "automationValue", hitAreaChevronAriaLabel: "hitAreaChevronAriaLabel", seeAllText: "seeAllText", availableAppointmentsText: "availableAppointmentsText", appointments: "appointments", appointmentDisplayValue: "appointmentDisplayValue", isHitArea: "isHitArea", elementId: "elementId", styleClasses: "styleClasses", tabindex: ["data-tabindex", "tabindex"], headerIcon: "headerIcon", headerTitle: "headerTitle", footerTitle: "footerTitle", resetPaddings: "resetPaddings", hitAreaLabel: "hitAreaLabel" }, outputs: { hitAreaClick: "hitAreaClick", appointmentItemClick: "appointmentItemClick" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c5, decls: 7, vars: 2, consts: [["class", "panel panel-interactive", 3, "ngClass", 4, "ngIf", "ngIfElse"], ["defaultPanel", ""], ["modalTemplate", ""], ["footerContent", ""], [1, "panel", "panel-interactive", 3, "ngClass"], [3, "ngClass", 4, "ngIf"], ["class", "hit-area", 3, "elementId", "styleClasses", "aw-aria-label", "onClick", 4, "ngIf"], [3, "ngClass"], ["class", "panel-footer-heading", 4, "ngIf"], [1, "panel-footer-content"], [1, "panel-footer-content-inner", 3, "scroll"], ["panelFooter", ""], [4, "ngIf", "ngIfElse"], ["styleClasses", "panel-footer-scroll-btn panel-footer-scroll-btn-left", 3, "aw-aria-label", "onClick", 4, "ngIf"], ["styleClasses", "panel-footer-scroll-btn panel-footer-scroll-btn-right", 3, "aw-aria-label", "onClick", 4, "ngIf"], [1, "flex", "items-center", "flex-row", "flex-auto"], ["class", "material-icons-outlined", "aria-hidden", "true", 4, "ngIf"], [1, "panel-title"], ["aria-hidden", "true", 1, "material-icons-outlined"], [1, "hit-area", 3, "elementId", "styleClasses", "aw-aria-label", "onClick"], [1, "panel-hit-area-chevron"], [1, "panel-footer-heading"], [1, "flex", "panel-footer-title"], ["styleClasses", "btn-flat panel-footer-see-all-btn", 3, "elementId", "onClick"], [4, "ngFor", "ngForOf"], ["styleClasses", "btn btn-small progress-v2", "progressive", "true", 3, "progress", "elementId", "onClick"], ["styleClasses", "panel-footer-scroll-btn panel-footer-scroll-btn-left", 3, "aw-aria-label", "onClick"], ["aria-hidden", "true", 1, "material-icons-outlined", "panel-footer-btn-icon"], ["styleClasses", "panel-footer-scroll-btn panel-footer-scroll-btn-right", 3, "aw-aria-label", "onClick"], [1, "panel", 3, "ngClass"], [1, "modal-content-wrapper"], [1, "modal-heading", "no-border"], [1, "panel-modal-title"], ["automationValue", "buttonClose", "styleClasses", "mat-dialog-close icon-link", 3, "elementId", "mat-dialog-close"], [1, "material-icons-outlined"], [1, "modal-content", "panel-modal-content"], [1, "panel-modal-content-inner"]], template: function AwPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c4);
        ɵngcc0.ɵɵtemplate(0, AwPanelComponent_div_0_Template, 13, 20, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AwPanelComponent_ng_template_1_Template, 5, 4, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, AwPanelComponent_ng_template_3_Template, 10, 4, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, AwPanelComponent_ng_template_5_Template, 1, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isInteractive)("ngIfElse", _r1);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc3.AwButtonComponent, ɵngcc2.NgForOf, ɵngcc1.MatDialogClose], pipes: [ɵngcc2.AsyncPipe], encapsulation: 2 });
AwPanelComponent.selectorDowngrade = 'aw-panel';
AwPanelComponent.ctorParameters = () => [
    { type: MatDialog },
    { type: ChangeDetectorRef }
];
AwPanelComponent.propDecorators = {
    panelFooter: [{ type: ViewChild, args: ['panelFooter',] }],
    modalTemplate: [{ type: ViewChild, args: ['modalTemplate', { static: true },] }],
    elementId: [{ type: Input }],
    styleClasses: [{ type: Input }],
    tabindex: [{ type: Input, args: ['data-tabindex',] }],
    isInteractive: [{ type: Input }],
    automationValue: [{ type: Input }],
    headerIcon: [{ type: Input }],
    headerTitle: [{ type: Input }],
    footerTitle: [{ type: Input }],
    resetPaddings: [{ type: Input }],
    hitAreaChevronAriaLabel: [{ type: Input }],
    seeAllText: [{ type: Input }],
    availableAppointmentsText: [{ type: Input }],
    hitAreaLabel: [{ type: Input }],
    hitAreaClick: [{ type: Output }],
    appointmentItemClick: [{ type: Output }],
    appointments: [{ type: Input }],
    appointmentDisplayValue: [{ type: Input }],
    isHitArea: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwPanelComponent, [{
        type: Component,
        args: [{
                selector: 'aw-panel',
                template: "<div\n    *ngIf=\"isInteractive; else defaultPanel\"\n    class=\"panel panel-interactive\"\n    [attr.automation]=\"automationValue\"\n    [attr.id]=\"elementId\"\n    [attr.tabindex]=\"tabindex\"\n    [ngClass]=\"classes\">\n    <header *ngIf=\"headerIcon || headerTitle\" [ngClass]=\"{'panel-heading': true, 'p-l0 p-r0': resetPaddings}\">\n        <div class=\"flex items-center flex-row flex-auto\">\n            <i class=\"material-icons-outlined\" aria-hidden=\"true\" *ngIf=\"headerIcon\">{{headerIcon}}</i>\n            <h6 class=\"panel-title\">{{headerTitle}}</h6>\n        </div>\n    </header>\n    <aw-button\n        *ngIf=\"isHitArea\"\n        class=\"hit-area\"\n        [elementId]=\"elementIdWithPrefix('panel-hit-area')\"\n        (onClick)=\"hitAreaClicked()\"\n        [styleClasses]=\"areaStyleClasses\"\n        [aw-aria-label]=\"hitAreaLabel\"\n    >\n        <ng-content select=\"[aw-panel-hit-area]\"></ng-content>\n        <span class=\"panel-hit-area-chevron\">\n            <i class=\"material-icons-outlined\" aria-hidden=\"true\">chevron_right</i>\n        </span>\n    </aw-button>\n    <footer [ngClass]=\"{'panel-footer': isFooterVisible | async, 'hide': !(isFooterVisible | async), 'p-l0 p-r0': resetPaddings}\">\n        <div class=\"panel-footer-heading\" *ngIf=\"appointments.length\">\n            <p class=\"flex panel-footer-title\">{{footerTitle}}</p>\n            <aw-button styleClasses=\"btn-flat panel-footer-see-all-btn\" [elementId]=\"elementIdWithPrefix('panel-see-all-btn')\" (onClick)=\"onSeeAllAppointmentsClick()\">\n                {{ seeAllText }}\n            </aw-button>\n        </div>\n        \n        <div class=\"panel-footer-content\">\n            <div class=\"panel-footer-content-inner\" #panelFooter  (scroll)=\"scrollFooter(panelFooter)\">\n                <ul *ngIf=\"appointments.length; else footerContent\">\n                    <ng-container *ngFor=\"let appointment of appointments; index as i\">\n                        <li>\n                            <aw-button\n                                styleClasses=\"btn btn-small progress-v2\"\n                                progressive=\"true\"\n                                [progress]=\"appointment.loading && !dialogRef\"\n                                [elementId]=\"elementIdWithPrefix('panel-appointment-btn-' + i)\"\n                                (onClick)=\"appointmentItemClicked(appointment)\"\n                            >\n                                {{ appointmentDisplayValue(appointment) }}\n                            </aw-button>\n                        </li>\n                    </ng-container>\n                </ul>\n            </div>\n            <aw-button\n                *ngIf=\"footerScrollPosition > footerScrollOffset\"\n                styleClasses=\"panel-footer-scroll-btn panel-footer-scroll-btn-left\"\n                [aw-aria-label]=\"scrollBack\"\n                (onClick)=\"sideScroll(panelFooter, 'right', 80)\">\n                <span class=\"material-icons-outlined panel-footer-btn-icon\" aria-hidden=\"true\">navigate_before\n                </span>\n            </aw-button>\n            <aw-button\n                *ngIf=\"footerScrollPosition < footerScrollWidth\"\n                styleClasses=\"panel-footer-scroll-btn panel-footer-scroll-btn-right\"\n                [aw-aria-label]=\"scrollForward\"\n                (onClick)=\"sideScroll(panelFooter, 'left', 80)\">\n                <span class=\"material-icons-outlined panel-footer-btn-icon\" aria-hidden=\"true\">navigate_next</span>\n            </aw-button>\n        </div>\n    </footer>\n</div>\n<ng-template #defaultPanel>\n    <div\n        class=\"panel\"\n        [attr.automation]=\"automationValue || 'panelComponent'\"\n        [attr.id]=\"elementId\"\n        [attr.tabindex]=\"tabindex\"\n        [ngClass]=\"styleClasses\">\n        <ng-content select=\".panel-heading\"></ng-content>\n        <ng-content select=\".panel-body\"></ng-content>\n        <ng-content select=\".panel-footer\"></ng-content>\n        <ng-content select=\".panel-additional\"></ng-content>\n    </div>\n</ng-template>\n\n<ng-template #modalTemplate>\n    <div class=\"modal-content-wrapper\">\n        <div class=\"modal-heading no-border\">\n            <h4 class=\"panel-modal-title\">{{ availableAppointmentsText }}</h4>\n            <aw-button\n            automationValue=\"buttonClose\"\n            styleClasses=\"mat-dialog-close icon-link\"\n            [elementId]=\"elementIdWithPrefix('panel-modal-close-btn')\"\n            [mat-dialog-close]=\"true\">\n            <i class=\"material-icons-outlined\">close</i>\n        </aw-button>\n        </div>\n        <div class=\"modal-content panel-modal-content\">\n            <ul class=\"panel-modal-content-inner\">\n                <ng-container *ngFor=\"let appointment of appointments; index as i\">\n                   <li>\n                       <aw-button\n                            styleClasses=\"btn btn-small progress-v2\"\n                            progressive=\"true\"\n                            [progress]=\"appointment.loading && !!dialogRef\"\n                            [elementId]=\"elementIdWithPrefix('panel-modal-appointment-btn-' + i)\"\n                            (onClick)=\"appointmentItemClicked(appointment)\"\n                        >\n                            {{ appointmentDisplayValue(appointment) }}\n                        </aw-button>\n                    </li>\n                </ng-container>\n            </ul>\n        </div>\n    </div>\n</ng-template>\n\n<ng-template #footerContent>\n    <ng-content select=\"[aw-panel-footer-content]\"></ng-content>\n</ng-template>\n"
            }]
    }], function () { return [{ type: ɵngcc1.MatDialog }, { type: ɵngcc0.ChangeDetectorRef }]; }, { isInteractive: [{
            type: Input
        }], automationValue: [{
            type: Input
        }], hitAreaChevronAriaLabel: [{
            type: Input
        }], seeAllText: [{
            type: Input
        }], availableAppointmentsText: [{
            type: Input
        }], hitAreaClick: [{
            type: Output
        }], appointmentItemClick: [{
            type: Output
        }], appointments: [{
            type: Input
        }], appointmentDisplayValue: [{
            type: Input
        }], isHitArea: [{
            type: Input
        }], panelFooter: [{
            type: ViewChild,
            args: ['panelFooter']
        }], modalTemplate: [{
            type: ViewChild,
            args: ['modalTemplate', { static: true }]
        }], elementId: [{
            type: Input
        }], styleClasses: [{
            type: Input
        }], tabindex: [{
            type: Input,
            args: ['data-tabindex']
        }], headerIcon: [{
            type: Input
        }], headerTitle: [{
            type: Input
        }], footerTitle: [{
            type: Input
        }], resetPaddings: [{
            type: Input
        }], hitAreaLabel: [{
            type: Input
        }] }); })();

class AwPanelModule {
}
AwPanelModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwPanelModule });
AwPanelModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwPanelModule_Factory(t) { return new (t || AwPanelModule)(); }, imports: [[
            CommonModule,
            AwButtonModule,
            MatDialogModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwPanelModule, { declarations: function () { return [AwPanelComponent]; }, imports: function () { return [CommonModule,
        AwButtonModule,
        MatDialogModule]; }, exports: function () { return [AwPanelComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwPanelModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AwButtonModule,
                    MatDialogModule
                ],
                declarations: [
                    AwPanelComponent
                ],
                exports: [
                    AwPanelComponent
                ]
            }]
    }], null, null); })();

export { AwPanelComponent, AwPanelModule };

//# sourceMappingURL=aw-ads-components-aw-panel.js.map